import React, { useState, useEffect, Component } from 'react';
import { Link } from 'react-router-dom';
import admin from "../../images/banner/admin.png";
import view from "../../images/icon/view.png";
import download from "../../images/icon/download.png";
import "bootstrap-icons/font/bootstrap-icons.css";
import axios from 'axios';
import Viewreqdocument from './Viewreqdocument';

const Reqcandidates = () => {
    const [records, setRecords] = useState([]);
    const [file, setFile] = useState(false);
    const [modalshow, setModalshow] = useState(false);
    const handleModalShow = (filename) =>{
            setModalshow(true);
            setFile(filename);
        } 
    let userdetail = JSON.parse(sessionStorage.getItem('userdetail'));
    const id = window.location.href.split('/')[5]

    const servicesStyle = {
        backgroundImage: `url(${admin})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
        backgroundColor :'#e6f4ff',
        width :'100%',
        height: '33vh',
    };

    useEffect(() => {
        axios.get(`https://api.transnational.ai/api/reqcandidates/${id}`) 
            .then(response => {
                console.log(response.data)
                setRecords(response.data.candidates);
            })
            .catch(error => {
                console.error('Error fetching records:', error);
            });
    }, []); 

    const handleDownload = (id) => {
        axios({
            url: `https://api.transnational.ai/api/reqdownloadfile/${id}`, 
            method: 'GET',
            responseType: 'blob', 
        })
        .then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${id}`);
            document.body.appendChild(link);
            link.click();
        })
        .catch(error => {
            console.error('Error downloading file: ', error);
        });
        
    };
   

    return (
        <section style={{ background :'#f4f4f4' }}>
                <section id="bannerSection" style={servicesStyle}>
                    <div className="container">
                        <h1 id="HR"></h1>
                    </div>
                </section>
                <div className="container" style={{ background :'#ffffff' }}>
                    <div className="col-12" style={{ margin:'0 auto'}}>
                        <div className="well well-small" style={{ textAlign:"left" }}>
                            <ul className="media-list">
                                <li className="media well well-small" style={{ marginTop:'10px',marginLeft:'-15px',marginRight:'15px',marginBottom:'-5px'}}>
                                    <section className="breadcrumb" style={{ marginLeft:'5px', marginTop:'5px',marginRight:'5px'}}>
                                        <div  className="col-md-12 breadcrumbs" >
                                            <a href="/admin/Dashboard">Home</a> <i class="bi bi-chevron-double-right"></i> <a href="/admin/Clientdashboard">CT Group Dashboard</a> <i class="bi bi-chevron-double-right"></i> <a href="/admin/Clients">All Clients</a> <i class="bi bi-chevron-double-right"></i> <span> Requirements</span>
                                        </div>
                                    </section>
                                    
                                    <div className="media-body" style={{ minHeight : '500px' , padding : '40px',marginTop:"30px"}}>
                                        <h3 className="media-heading"></h3>
                                        
                                        <table className="mytable">
                                        <thead>
                                            <tr>
                                            <th>Name</th>
                                            <th>Feedback</th>
                                            <th>Status</th>
                                            <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        {records.map(record => (
                                            <tr  key={record.id}>
                                            <td>{record.name}</td>
                                            <td>{record.feedback}</td>
                                            <td>{record.status}</td>
                                            <td><a href="#" onClick={()=>handleModalShow(record.resume)}><img src={view} width={20} height={20} /></a>&nbsp;<a href="#" onClick={() => handleDownload(record.resume)}><img src={download} width={20} height={20} /></a></td>
                                            </tr>
                                        ))} 
                                        </tbody>
                                        </table>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <Viewreqdocument show={modalshow} filename={file} close={() => setModalshow(false)} />
            </section>
    );
};

export default Reqcandidates;